import React from 'react';
import PropTypes from 'prop-types';

import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import { useInput } from 'react-admin';

import ImageChooserButton from './image_chooser_button';
import ImageUploaderButton from './image_uploader_button';

const ThumbnailInput = ({
    required,
    ...props
}) => {
    const { field, fieldState } = useInput(props);

    const handleChooserChoice = React.useCallback((image) => {
        field.onChange(image);
    }, [field]);

    const handleImageUploaded = React.useCallback((image) => {
        field.onChange(image);
    }, [field]);

    return (
        <Grid container sx={{ width: '100%' }} spacing={2} >
            {
                field.value ?
                    <Grid size={12}>
                        <img
                            src={field.value.source}
                            alt={field.value.alt}
                            style={{ maxWidth: '100%' }}
                        />
                    </Grid> :
                    null
            }
            <Grid size={12}>
                <ImageChooserButton folderName="thumbnail" onImageChoosed={handleChooserChoice} />
                <ImageUploaderButton folderName="thumbnail" onImageUploaded={handleImageUploaded} />
            </Grid>
            { fieldState.touched && fieldState.error ? <Grid size={12}><FormHelperText>{fieldState.error}</FormHelperText></Grid> : null }
        </Grid>
    );
};

ThumbnailInput.propTypes = {
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    resource: PropTypes.string,
    source: PropTypes.string,
    required: PropTypes.bool,
};

export default React.memo(ThumbnailInput);
